module.exports = __webpack_public_path__ + "static/media/help_selected.768808af.svg";